import { render } from "./SearchOption.vue?vue&type=template&id=3945946c&ts=true"
import script from "./SearchOption.vue?vue&type=script&lang=ts"
export * from "./SearchOption.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__